// Hilfsfunktionen für FridgeBuddy

// Kategorie-Icons und Labels
export const CATEGORIES = {
  milchprodukte: { icon: '🥛', label: 'Milchprodukte' },
  fleisch: { icon: '🥩', label: 'Fleisch & Wurst' },
  fisch: { icon: '🐟', label: 'Fisch' },
  obst: { icon: '🍎', label: 'Obst' },
  gemuese: { icon: '🥬', label: 'Gemüse' },
  brot: { icon: '🍞', label: 'Brot & Backwaren' },
  getraenke: { icon: '🥤', label: 'Getränke' },
  tiefkuehl: { icon: '🧊', label: 'Tiefkühl' },
  konserven: { icon: '🥫', label: 'Konserven & Vorrat' },
  gewuerze: { icon: '🧂', label: 'Gewürze & Soßen' },
  suessigkeiten: { icon: '🍫', label: 'Süßigkeiten & Snacks' },
  sonstiges: { icon: '📦', label: 'Sonstiges' },
};

// Tage bis Ablauf berechnen
export function daysUntilExpiry(expiryDate) {
  if (!expiryDate) return null;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const expiry = new Date(expiryDate);
  expiry.setHours(0, 0, 0, 0);
  return Math.ceil((expiry - today) / (1000 * 60 * 60 * 24));
}

// Ablauf-Status ermitteln
export function getExpiryStatus(expiryDate) {
  const days = daysUntilExpiry(expiryDate);
  if (days === null) return { label: 'Kein MHD', class: 'ok', days: null };
  if (days < 0) return { label: `${Math.abs(days)} Tag${Math.abs(days) !== 1 ? 'e' : ''} abgelaufen`, class: 'danger', days };
  if (days === 0) return { label: 'Heute!', class: 'danger', days };
  if (days === 1) return { label: 'Morgen', class: 'warning', days };
  if (days <= 3) return { label: `${days} Tage`, class: 'warning', days };
  return { label: `${days} Tage`, class: 'ok', days };
}

// Datum formatieren (deutsch)
export function formatDate(dateStr) {
  if (!dateStr) return '';
  const d = new Date(dateStr);
  return d.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' });
}

// Items nach Kategorie gruppieren
export function groupByCategory(items) {
  const groups = {};
  for (const item of items) {
    const cat = item.category || 'sonstiges';
    if (!groups[cat]) groups[cat] = [];
    groups[cat].push(item);
  }
  // Sortiere nach Kategorie-Reihenfolge
  const order = Object.keys(CATEGORIES);
  return Object.entries(groups).sort(([a], [b]) => order.indexOf(a) - order.indexOf(b));
}

// Items die bald ablaufen
export function getExpiringItems(items, withinDays = 3) {
  return items.filter(item => {
    const days = daysUntilExpiry(item.expiry_date);
    return days !== null && days <= withinDays;
  });
}

// Text für Rezept-Export generieren
export function generateRecipeText(items) {
  const lines = items.map(item => {
    const qty = item.quantity && item.quantity !== 1 ? `${item.quantity} ${item.unit || 'Stk'} ` : '';
    return `- ${qty}${item.name}`;
  });
  return `Ich habe folgende Zutaten und möchte daraus ein Rezept kochen:\n\n${lines.join('\n')}\n\nSchlage mir bitte ein einfaches Rezept vor, das möglichst viele dieser Zutaten verwendet.`;
}

// Haushalt-Code aus localStorage
export function getStoredHousehold() {
  try {
    return JSON.parse(localStorage.getItem('fridgebuddy_household'));
  } catch {
    return null;
  }
}

export function storeHousehold(household) {
  localStorage.setItem('fridgebuddy_household', JSON.stringify(household));
}

export function clearHousehold() {
  localStorage.removeItem('fridgebuddy_household');
}
